<template>
<div>
  <top-header></top-header>
<main-menu></main-menu>
<!-- Start the code for this screen here -->
  <div class="pagecontainer">
  <div class="container">
    <div class="heading"><span><b>Add Activity</b></span></div>
    <div v-if="failure">
       <p align ="center" class="alert-danger"> {{failureMessage}} </p>
     </div>
    <div class="form-group">
      <label name="Activity Date"> Activity Date </label>
      <input type="Date"  v-validate="'required'" v-model.trim="activity.activityDate"/>
      <label id="aType" name="Activity Type" >Activity Type</label>
        <select v-validate="'required'" v-model.trim="activity.activityType"  style="width: 10.6%;">
        <option disabled value=""> Select activity Type </option>
        <option v-for="activityT in activtyTypes" v-bind:value="activityT.key" v-bind:key="activityT.key"> {{ activityT.value}} </option>
      </select>
      <label id="aSource" name="Activity Source" >Activity Source</label>
        <select v-validate="'required'" v-model.trim="activity.activitySource" style="width: 10.6%;"  @change="updatePurpose">
        <option disabled value=""> Select source </option>
        <option v-for="activityS in activitySource" v-bind:value="activityS.key" v-bind:key="activityS.key"> {{ activityS.value}} </option>
      </select>
    </div>
    <div class="form-group">
      <label id="Dealer" name="Dealer Name" >Dealer Name</label>
        <select v-validate="'required'" v-model.trim="activity.dealerId" style="width: 10.6%;" :disabled="isDealerDisabled">
        <option disabled value=""> Select Dealer </option>
        <option v-for="dealer in dealerNames" v-bind:value="dealer.dealerId" v-bind:key="dealer.dealerId"> {{ dealer.dealerName}} </option>
      </select>
      <label id="vpurpose" name="Visit Purpose" >Visit Purpose</label>
        <select v-validate="'required'" v-model.trim="activity.visitPurpose" style="width: 10.6%;">
        <option disabled value=""> Select purpose </option>
        <option v-for="vp in visitPurpose" v-bind:value="vp.key" v-bind:key="vp.key"> {{ vp.value}} </option>
      </select>
      <label id="vQuality" name="Visit Quality" >Visit Quality</label>
        <select v-validate="'required'" v-model.trim="activity.visitQuality" style="width: 10.6%;">
        <option disabled value=""> Select Quality </option>
        <option v-for="vq in visitQuality" v-bind:value="vq.key" v-bind:key="vq.key"> {{ vq.value}} </option>
      </select>
    </div>
    <div class="form-group">
      <label id="notes" name="Notes"> Notes </label>
      <textarea v-model.trim="activity.notes"  v-validate="'required'" spellcheck="true" placeholder="add notes"
      rows="5" cols="20" style="width: 52.4%;" :maxlength="250" />
      <button class="btn-blue-save" style="width:5%;" type="submit" @click="saveActivity"> Save </button>
    </div>
    <br> <br>
    <!-- horizontal line break -->
    <div class="horizontal-line"></div>
    <!-- Table Data start-->
        <table id="activitytable" class="table-month-table">
			    <tr class="table-month-row">
            <th v-for="(col,index) in colheaders" :key="index" class="table-month-header-blue"><span >{{col.header}}</span></th>
			    </tr>
			    <tr v-for="(activity,dindex) in activitiesForDisplay" :key="dindex"  class="table-month-row">
            <td class="table-month-td">
              {{activity.activityDate}}
            </td>
            <td class="table-month-td">
              {{activity.activityType}}
            </td>
            <td class="table-month-td">
              {{activity.activitySourceType}}
            </td>
            <td class="table-month-td">
              {{activity.dealerName}}
            </td>
            <td class="table-month-td">
              {{activity.visitPurposeType}}
            </td>
            <td class="table-month-td">
              {{activity.visitQuality}}
            </td>
            <td class="table-month-td">
              {{activity.activityNotes}}
            </td>
           <!-- <td class="table-month-td" v-on:click="deleteActivity(activity.activityId)">
              Delete
            </td> -->
            <td class="table-month-td">
                <button class="btn-blue-save" style="width:60%;" type="submit" @click="deleteActivity(activity.activityId)">Delete</button>
            </td>
          </tr>
			</table>

  </div> <!-- Container DIV Tag end-->
  <!-- End of the code for this screen here -->
  </div> <!-- Page Container DIV Tag end-->
   <bottom-footer></bottom-footer>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import commonservice from '../js/http-common'
import activityTraking from '../js/http-activitytracking'
import manageSourceSvc from '../js/http-managesource'
import manageemployeeSvc from '../js/http-employee.js'
import { stringify } from 'querystring'

export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'addacivity',
  data () {
    return {
      activtyTypes: [
        { key: 'Visit', value: 'Visit' },
        { key: 'Phone Contact', value: 'Phone Contact' },
        { key: 'Email Contact', value: 'Email Contact' }
      ],
      activitySource: [
        { key: 'Dealer', value: 'Dealer' },
        { key: 'Event', value: 'Event' }
      ],
      dealerNames: [], // data comes from service. Only get Assigned dealer for the REP
      visitPurpose: [],
      visitQuality: [
        { key: '1', value: '1' },
        { key: '2', value: '2' },
        { key: '3', value: '3' },
        { key: '4', value: '4' },
        { key: '5', value: '5' }
      ],
      activity: this.initializedata(), // intialize activty entry fields
      saved: false,
      // message:"",
      failure: false,
      failureMessage: "We're sorry, We're unable to save activity information at the moment, please try back later",
      colheaders: [
        { header: 'Activity Date' },
        { header: 'Activity Type' },
        { header: 'Activity Source' },
        { header: 'Dealer Name' },
        { header: 'Visit Purpose' },
        { header: 'Visit Quality' },
        { header: 'Notes' },
        { header: 'Action' }
      ],
      activitiesForDisplay: []
    }
  },
  methods: {
    updatePurpose: function (event) {
      if (this.activity.activitySource != '') {
        if (this.activity.activitySource == 'Dealer') {
          this.visitPurpose = [
            { key: 'Active Dealer visit', value: 'Active Dealer visit' },
            { key: 'New Dealer Visit', value: 'New Dealer Visit' },
            { key: 'Chip Program Enrollment', value: 'Chip Program Enrollment' },
            { key: 'Process Training', value: 'Process Training' },
            { key: 'Other', value: 'Other' }
          ]
          this.getAssignedDealers(this.$session.get('employee_id'))
        } else {
          this.visitPurpose = [
            { key: 'Local Events', value: 'Local Events' },
            { key: 'Shows', value: 'Shows' },
            { key: 'Other', value: 'Other' }
          ]
        }
      }
    },
    initializedata () {
      return {
        activityId: '',
        activityDate: '',
        activityType: '',
        activitySource: '',
        dealerId: '',
        visitPurpose: '',
        visitQuality: '',
        notes: '',
        createdDate: '',
        createdUserId: ''
      }
    },
    saveActivity () {
      this.failure = false
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          var date = new Date()
          var currentDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()
          let activityPayload = {
            'activityD': this.activity.activityDate,
            'activityType': this.activity.activityType,
            'activitySourceType': this.activity.activitySource,
            'dealerId': this.activity.dealerId,
            'visitPurposeType': this.activity.visitPurpose,
            'visitQuality': this.activity.visitQuality,
            'activityNotes': this.activity.notes,
            'employeeId': this.$session.get('employee_id'), // get from Session this.
            'creationD': currentDate,
            'creationUserI': this.$session.get('user_id')
          }
          console.log('Activity to be saved:' + JSON.stringify(activityPayload))
          // Save
          activityTraking.post('/', activityPayload)
            .then(response => {
              var savedActivity = response.data
              console.log('Saved Activity:' + JSON.stringify(savedActivity))
              // TODO - Need the Activity ID from the API - Change API to get ID as well?
              // if(status=="CREATED"){
              if (savedActivity != null && savedActivity.activityId != 0) {
                console.log('Activity saved successfully!!')
                this.errors.clear()
                this.$validator.reset()
                this.activity = this.initializedata()
                // get the activity info from system
                activityTraking.get('/' + savedActivity.activityId).then(Response => {
                  console.log('Activity returned:' + JSON.stringify(Response.data))
                  // update the table below
                  this.activitiesForDisplay.unshift(Response.data)
                })
              }
              // else if (status=="BAD_REQUEST"){
              // console.log("Failed to save Dealer!!");
              // this.failure = true;
              // }
              else {
                console.log('Failed to save Activity!!')
                this.failure = true
              }
              // TODO= Handle following scenarios - 500 or any other Status Codes
            })
            .catch(e => {
              console.log('Failed: ' + e)
              this.failure = true
            })
        } // end if
      })
    },
    deleteActivity (actId) {
      activityTraking.delete('/' + actId).then(Response => {
        var status = Response.data
        console.log('Deleted resonse' + status)
        if (status == 'OK') {
          // TODO - Find a way to remove element from array with specific ID OR make Retreive Call to get Fresh Data
          retrieveActivities()
        } else {
          // message that failed to delete?
          console.log('Error deleting activity')
        }
      })
    },
    retrieveActivities () { // TODO Get only for 1 Week on Page Load
      activityTraking.get('/search', { params: {
        agentId: this.$session.get('employee_id')
        // fromDate: this.searchCriteria.fromDate,
        // toDate: this.searchCriteria.toDate
      }
      }).then(response => {
        // console.log("Search Results:"+ JSON.stringify(response.data))
        this.activitiesForDisplay = response.data
      }).catch(e => {
        console.log('Error during search API call')
        this.activitiesForDisplay = []
      })
    },
    getAssignedDealers (repId) {
      manageemployeeSvc.get('/employee/salesrepdealers/' + repId).then(Response => {
        if (Response.data.length != 0) {
          this.dealerNames = Response.data
        }
      })
        .catch(error => {
          console.log('Failed to load dealer list dropdown:' + error)
        })
    },
    fetchData () {
      // get activities
      this.retrieveActivities()
    }
  },
  mounted () {
    this.fetchData()
  },
  computed: {
  	isDealerDisabled: function () {
    	return (this.activity.activitySource != 'Dealer')
    }
  }
}
</script>
<style scoped>
</style>
